const THEME = {
	primary: '#1B8E8A',
	secondary: '#FF7383',
	third: '#F9BE6C',
	success: '#1B8E8A',
	warning: '#F9BE6C',
	error: '#FF7383',
}

export default THEME;
